'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _config = require('config');

var _lodashCollectionFilter = require('lodash/collection/filter');

var _lodashCollectionFilter2 = _interopRequireDefault(_lodashCollectionFilter);

var _lodashArrayFirst = require('lodash/array/first');

var _lodashArrayFirst2 = _interopRequireDefault(_lodashArrayFirst);

var _underscoreStringInclude = require('underscore.string/include');

var _underscoreStringInclude2 = _interopRequireDefault(_underscoreStringInclude);

// Prefix links for Github Pages.
// TODO make this generic for all prefixing?
var link = exports.link = function (_link) {
  if (typeof __PREFIX_LINKS__ !== 'undefined' && __PREFIX_LINKS__ !== null && __PREFIX_LINKS__ && _config.config.linkPrefix !== null) {
    return _config.config.linkPrefix + _link;
  } else {
    return _link;
  }
};

// Get the child pages for a given template.
exports.templateChildrenPages = function (filename, state) {
  // Pop off the file name to leave the relative directory
  // path to this template.
  var split = filename.split('/');
  split.pop();
  var result = '/' + split.join('/');

  result = link(result);

  var childrenRoutes = (0, _lodashArrayFirst2['default'])((0, _lodashCollectionFilter2['default'])(state.routes, function (route) {
    return (0, _underscoreStringInclude2['default'])(route.path, result);
  })).childRoutes;

  var childrenPaths = childrenRoutes.map(function (path) {
    return path.path;
  });

  var childPages = undefined;
  if (childrenPaths) {
    childPages = (0, _lodashCollectionFilter2['default'])(_config.pages, function (page) {
      return childrenPaths.indexOf(link(page.path)) >= 0;
    });
  } else {
    childPages = [];
  }

  return childPages;
};


/** WEBPACK FOOTER **
 ** ../~/gatsby/dist/isomorphic/gatsby-helpers.js
 **/